import React, { useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import usePasswordToggle from '../../hooks copy/usePasswordToggle';
import useMuiButtonLoader from '../../hooks copy/useMuiButtonLoader';
import { Input } from '../../components/Form';
import useButtonLoader from '../../hooks/UseButtonLoader';
import { resetPasswordApi } from '../../services/auth/Auth';
import toast from 'react-hot-toast';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import { catchMessage, elseMessage, successMessage } from '../../comman/Message';


const ResetPassword = () => {
    const navigate = useNavigate()
    const [inputType, Icon] = usePasswordToggle("small")
    const [inputType1, Icon1] = usePasswordToggle("small")

    const [error, setError] = useState({});
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    const [login, setLogin] = useState({ newPassword: "", confirmPassword: "", });
    const [buttonref, buttonLoader] = useButtonLoader("Change password", "#28B17B")
    const otp = localStorage.getItem("otp")
    const email = localStorage.getItem("email")

    const handleValidation = () => {
        const error = {};
        let status = true;

        if (!login.newPassword) {
            error["newPassword"] = "Please Enter Your new Password";
            status = false;
        }
        if (!login.confirmPassword) {
            error["confirmPassword"] = "Please Enter Your password confirm";
            status = false;
        }
        if (login.newPassword !== login.confirmPassword) {
            toast.error("Password & Confirm Password should be the same");
            status = false;
        }

        setError(error);
        return status;
    };

    const onChangeHandler = (event) => {
        const { name, value } = event.target;
        setLogin({ ...login, [name]: value });
    };


    const resetPassword = async (e) => {
        e.preventDefault()
        if (handleValidation()) {
            try {
                buttonLoader(true)
                const res = await resetPasswordApi({ ...login, otp: otp, email: email })
                if (res?.data?.status === 200) {
                    successMessage(res)
                    buttonLoader(false)
                    navigate("/password-reset-success")
                    localStorage.removeItem("otp")
                    localStorage.removeItem("email")
                }
                else {
                    elseMessage(res)
                    buttonLoader(false)
                }
            } catch (e) {
                buttonLoader(false)
                catchMessage(e)
            }
        }
    }

    return (
        <>
            <div className="LoginArea">
                <h1 className='login_head'>Neptune</h1>
                <div className="LoginBox">
                    <h5 className='mt-2'>Reset Password</h5>
                    <form>
                        <div className="form-group">
                            <Input
                                type={inputType}
                                name="newPassword"
                                value={login.newPassword}
                                onChange={onChangeHandler}
                                placeholder="Enter Password"
                                className={`form-control password`}
                                label={"New Password"}
                                error={error.newPassword}
                                // maxLength={15}
                                leftIcon={
                                    <span className='Icon'>
                                        <LockOpenTwoToneIcon />
                                    </span>
                                }
                            />
                            {/* <span className={error.password ? "error_icon" : "icon"}>{Icon}</span> */}
                            <span className="icon">{Icon}</span>


                        </div>

                        <div className="form-group">
                            <Input
                                type={inputType1}
                                name="confirmPassword"
                                value={login.confirmPassword}
                                onChange={onChangeHandler}
                                placeholder="Enter Password"
                                className={`form-control password`}
                                label={"Confirm Password"}
                                error={error.confirmPassword}
                                // maxLength={15}
                                leftIcon={
                                    <span className="Icon">
                                        <LockOpenTwoToneIcon />
                                    </span>
                                }
                            />
                            <span className="icon">{Icon1}</span>
                        </div>

                        <div className="form_btn">
                            <button className='login_btn' ref={buttonref} onClick={resetPassword} >
                                Change password <i className="fa fa-sign-in"></i>
                            </button>
                        </div>


                    </form>
                </div>
            </div>
        </>
    )
}

export default ResetPassword